// extracted by mini-css-extract-plugin
module.exports = {"controls":"ChatControls_controls_1ofeG9E","btnWrapper":"ChatControls_btnWrapper_2IjRikL","disabled":"ChatControls_disabled_15INZ5I","endButton":"ChatControls_endButton_3SqIpTc"};